import { gql } from 'graphql-request';

import { graphQLFragments } from 'shared/graphql/fragments';

const dealsPagePromotionsDataWithTags = gql`
  ${graphQLFragments.promotionShape}
  ${graphQLFragments.audiobookUserAudiobookPlayableShape}
  query FetchPromotions(
    $tagFilters: [String!]
    $sortKey: DealsPageSort
    $namedFilters: [DealsPageNamedFilter!]
    $maxPrice: Int
    $page: Int
    $pageSize: Int
  ) {
    dealsPagePromotionsDataWithTags(
      tagFilters: $tagFilters
      sortKey: $sortKey
      namedFilters: $namedFilters
      maxPrice: $maxPrice
    ) {
      totalCount
      objects(page: $page, pageSize: $pageSize) {
        ... on Promotion {
          ...promotionFields
          audiobook {
            currentBlurb {
              sanitizedText
            }
            promotedTags {
              id
            }
            displayNarrators
            sampleUrl
            ...audiobookUserAudiobookPlayableFields
          }
        }
      }
    }
  }
`;

const homepagePromotions = gql`
  ${graphQLFragments.promotionShape}
  query FetchPromotions($filter: PromotionFilter!, $page: Int, $pageSize: Int) {
    homepagePromotions(filter: $filter, page: $page, pageSize: $pageSize) {
      ...promotionFields
    }
  }
`;

const popularPromotions = gql`
  ${graphQLFragments.promotionShape}
  query FetchPopularPromotions($page: Int, $pageSize: Int, $omitAudiobookIds: [ID!]) {
    popularPromotions(page: $page, pageSize: $pageSize, omitAudiobookIds: $omitAudiobookIds) {
      ...promotionFields
    }
  }
`;

const relatedTagPromotions = gql`
  ${graphQLFragments.promotionShape}
  query FetchRelatedTagPromotions($ids: [ID!], $pageSize: Int, $excludeAudiobookId: ID) {
    tags(ids: $ids) {
      displayName
      url
      promotions(pageSize: $pageSize, excludeAudiobookId: $excludeAudiobookId) {
        ...promotionFields
      }
    }
  }
`;

const tagPromotions = gql`
  ${graphQLFragments.promotionShape}
  query FetchTagPromotions($tagSlug: String!, $page: Int, $pageSize: Int, $sortKey: String, $excludeAudiobookId: ID) {
    tag(slug: $tagSlug) {
      promotions(sortKey: $sortKey, page: $page, pageSize: $pageSize, excludeAudiobookId: $excludeAudiobookId) {
        ...promotionFields
      }
    }
  }
`;

export const promotionQueries = {
  dealsPagePromotionsDataWithTags,
  homepagePromotions,
  popularPromotions,
  relatedTagPromotions,
  tagPromotions,
};
